/**
 * Sender validation — mirrors the backend `PartySchema` in
 * apps/service-mail/src/modules/draft/draft.dto.ts. The shape MUST stay in
 * lockstep; the slice docs the source of truth as the backend Zod schema.
 *
 * We mirror by hand (rather than sharing a workspace lib) per slice scope.
 */
import { z } from 'zod';

export const SenderSchema = z.object({
  name: z.string().min(1, 'Sender name is required').max(200),
  phone: z.string().min(1, 'Sender phone is required').max(40),
  email: z.string().email('Invalid email').max(254).optional().or(z.literal('').transform(() => undefined)),
  addressLine1: z.string().min(1, 'Address line 1 is required').max(200),
  addressLine2: z.string().max(200).optional().or(z.literal('').transform(() => undefined)),
  city: z.string().min(1, 'City is required').max(80),
  state: z.string().min(1, 'State is required').max(80),
  postalCode: z.string().max(20).optional().or(z.literal('').transform(() => undefined)),
  countryCode: z.string().length(2, 'Country code must be 2 letters').default('NG'),
});

export type SenderValidated = z.infer<typeof SenderSchema>;
